module.exports = __webpack_public_path__ + "static/img/avatar_adopt.f81bd3f7.jpg";